module.exports = __webpack_public_path__ + "img/LogoLoading_circle02.0f4c8617.png";